import { ROUTE_NEXTGEN_VIEW } from "~/router/constants";

// Centralized in-app URL builders for nextgen project routes. Keep route
// strings here so a future rename is grep-once instead of grep-and-pray.

export const nextgenProjectsListPath = () => `${ROUTE_NEXTGEN_VIEW}/projects`;

export const nextgenProjectPath = (projectId: string) =>
  `${ROUTE_NEXTGEN_VIEW}/projects/${projectId}`;

export const nextgenConversationPath = (projectId: string, conversationId: string) =>
  `${ROUTE_NEXTGEN_VIEW}/projects/${projectId}/c/${conversationId}`;

export const nextgenSharedConversationPath = (token: string) =>
  `${ROUTE_NEXTGEN_VIEW}/shared/c/${token}`;

export const nextgenAdminConversationPath = (conversationId: string) =>
  `${ROUTE_NEXTGEN_VIEW}/admin/c/${conversationId}`;
